var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common_panel"},[_c('div',{staticClass:"titys"},[_vm._v(_vm._s(parseInt(Math.random() * (30 - 15 + 1) + 15)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }